import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(() => ({ root: { height: '2em' }}));
